module.exports = __webpack_public_path__ + "img/scene-mine.e27fedd5.jpg";